{
  "tabs": {
    "chat": "Comhrá",
    "reminders": "Cuimhneacháin",
    "calendar": "Féilire",
    "settings": "Socruithe"
  },
  "common": {
    "cancel": "Cealaigh",
    "save": "Sábháil",
    "confirm": "Deimhnigh",
    "delete": "Scrios",
    "back": "Ar ais",
    "close": "Dún",
    "edit": "Cuir in eagar",
    "search": "Cuardaigh",
    "all": "Gach",
    "loading": "Ag luchtú...",
    "error": "Tharla rud éigin",
    "notFound": "Níor aimsíodh",
    "tryAgain": "Bain triail eile as",
    "retry": "Athdhéan",
    "undo": "Cealaigh",
    "pullToRefresh": "Tarraing chun athnuachan",
    "justNow": "díreach anois"
  },
  "auth": {
    "welcome": "Fáilte go FishMemory",
    "tagline": "Do chúntóir cuimhneacháin WhatsApp, anois i do phóca.",
    "subtitle": "Do chúntóir cuimhneacháin WhatsApp, anois i do phóca.",
    "phoneLabel": "D’uimhir WhatsApp",
    "phoneHint": "Seolfaimid cód fíoraithe trí WhatsApp",
    "invalidPhone": "Cuir isteach uimhir ghutháin bhailí le do thoil",
    "continue": "Lean ar aghaidh",
    "enterPhone": "Cuir isteach d’uimhir WhatsApp",
    "phonePlaceholder": "Uimhir gutháin",
    "sendCode": "Seol Cód",
    "verifyTitle": "Fíoraigh d’uimhir",
    "otpSentTo": "Seoladh cód 6 dhigit chuig {{phone}} trí WhatsApp",
    "enterFullCode": "Cuir isteach na 6 dhigit go léir le do thoil",
    "invalidOtp": "Cód neamhbhailí. Bain triail eile as.",
    "otpFailed": "Theip ar sheoladh an chóid. Bain triail eile as.",
    "otpResent": "Cód athsheolta",
    "resendIn": "Athsheol i {{seconds}}s",
    "resendCode": "Athsheol cód",
    "enterOtp": "Cuir isteach an cód a seoladh chuig do WhatsApp",
    "verify": "Fíoraigh",
    "resend": "Athsheol cód",
    "wrongNumber": "Uimhir mícheart?",
    "backToPhone": "Ar ais chuig an uimhir",
    "editPhone": "Cuir in eagar uimhir gutháin",
    "error": "Earráid",
    "setupTitle": "Socraímis rudaí",
    "setupSubtitle": "Is féidir leat iad seo a athrú níos déanaí i Socruithe",
    "namePlaceholder": "D’ainm",
    "letsGo": "Críochnaigh an socrú",
    "skipForNow": "Scipeáil anois"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Clóscríobh teachtaireacht...",
    "inputPlaceholder": "Clóscríobh teachtaireacht...",
    "typing": "Tá FishMemory ag clóscríobh...",
    "online": "Ar líne",
    "connecting": "Ag nascadh...",
    "reconnecting": "Ag nascadh arís...",
    "offline": "As líne",
    "empty": "Tosaigh comhrá",
    "emptyHint": "Cruthaigh cuimhneacháin, seiceáil do sceideal, nó iarr cabhair.",
    "emptyAction": "Seol cuimhneachán samplach",
    "actions": "Gníomhartha comhrá",
    "keep": "Coinnigh teachtaireachtaí",
    "clearTitle": "Glan comhrá",
    "clearConfirm": "Scrios gach teachtaireacht ón bhfeiste seo? Ní féidir é seo a aisiompú.",
    "clear": "Glan comhrá",
    "optionSelected": "Roghnaithe: {{label}}",
    "sendingSelection": "Ag seoladh...",
    "connectionLost": "Ag nascadh arís..."
  },
  "reminders": {
    "title": "Mo Chuimhneacháin",
    "active": "Gníomhach",
    "today": "Inniu",
    "thisWeek": "An tseachtain seo",
    "history": "Stair",
    "items": "míreanna",
    "emptyTitle": "Níl cuimhneacháin fós",
    "emptySubtitle": "Cruthaigh ceann ón gcomhrá agus beidh sé le feiceáil anseo.",
    "emptyAction": "Oscail comhrá",
    "filterActive": "Gníomhach",
    "filterToday": "Inniu",
    "filterWeek": "An tseachtain seo",
    "filterHistory": "Stair",
    "emptyState": "Níl cuimhneacháin fós. Tosaigh ag comhrá!",
    "swipeDone": "Déanta",
    "swipeSnooze": "Snooze",
    "swipeDelete": "Scrios",
    "search": "Cuardaigh cuimhneacháin...",
    "upcoming": "Isteach",
    "completed": "Críochnaithe",
    "overdue": "Ró-dhéanach",
    "tomorrow": "Amárach",
    "synced": "Sioncronaithe {{value}}",
    "swipeHint": "Sleamhnaigh cuimhneachán le haghaidh gníomhartha breise",
    "noResults": "Níl aon chuimhneacháin ag teacht le do chuardach",
    "noResultsHint": "Bain triail as eochairfhocal eile nó glan an cuardach",
    "deleteAllFailed": "Theip ar scriosadh na gcuimhneachán go léir"
  },
  "calendar": {
    "title": "Féilire",
    "today": "Inniu",
    "tomorrow": "Amárach",
    "completed": "déanta",
    "noEvents": "Níl aon imeachtaí sceidealta",
    "noEventsSubtitle": "Roghnaigh dáta chun cuimhneacháin agus imeachtaí féilire a fheiceáil.",
    "googleEvent": "Féilire Google",
    "legendActive": "Gníomhach",
    "legendRecurring": "Athfhillteach",
    "legendDone": "Déanta",
    "legendGoogle": "Google",
    "previousMonth": "Mí roimhe",
    "nextMonth": "Mí seo chugainn",
    "previousYear": "Bliain roimhe",
    "nextYear": "Bliain seo chugainn",
    "goToToday": "Téigh go dtí inniu",
    "all": "Gach",
    "active": "Gníomhach",
    "done": "Déanta",
    "paused": "Ar sos"
  },
  "settings": {
    "title": "Socruithe",
    "profile": "Próifíl",
    "name": "Ainm taispeána",
    "enterName": "Cuir isteach d’ainm",
    "language": "Teanga",
    "uiLanguage": "Teanga an aip",
    "uiLanguageHelp": "Athraíonn sé comhéadan an aip, lipéid an fhéilire, agus treo an leagan amach ar an bhfeiste seo amháin.",
    "serverLanguage": "Teanga an chomhrá",
    "serverLanguageHelp": "Athraíonn sé teanga na bhfreagraí freastalaí agus na dteachtaireachtaí cuimhneacháin do do chuntas.",
    "timezone": "Crios ama",
    "currentTimezone": "Crios ama reatha",
    "timezoneHelp": "Taispeántar amanna cuimhneacháin go léir ag úsáid an chrios ama seo.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Sábháil crios ama",
    "timezoneSaved": "Nuashonraíodh crios ama",
    "detect": "Braite",
    "detectFailed": "Níorbh fhéidir crios ama a bhrath",
    "autoDetect": "Braite uathoibríoch ó GPS",
    "notifications": "Fógraí",
    "notificationsHelp": "Rialaíonn cuimhneacháin leanúnaacha foláirimh athfhillte tar éis cuimhneachán a sheoladh. Bainistítear ceadanna fógra ar leibhéal an ghléis fós i socruithe do ghutháin.",
    "pushEnabled": "Fógraí brúite",
    "autoDoneOnFire": "Marcáil go huathoibríoch mar dhéanta nuair a scaoiltear",
    "autoDoneOnFireDesc": "Nuair atá as, fanann cuimhneacháin gníomhach go dtí go marcálann tú iad mar dhéanta.",
    "googleCalendar": "Féilire Google",
    "google": "Féilire Google",
    "googleConnected": "Ceangailte",
    "googleDisconnected": "Níor ceangail",
    "googleConnectedHelp": "Is féidir cuimhneacháin nua a shioncronú go huathoibríoch le do fhéilire.",
    "googleDisconnectedHelp": "Ceangail Féilire Google chun cuimhneacháin agus imeachtaí a ailíniú.",
    "googleConnectFailed": "Theip ar nascadh le Féilire Google",
    "connected": "Ceangailte",
    "disconnected": "Níor ceangail",
    "connect": "Ceangail",
    "disconnect": "Dícheangail",
    "autoSync": "Sioncrónú uathoibríoch ar chuimhneacháin nua",
    "autosync": "Sioncrónú uathoibríoch ar chuimhneacháin nua",
    "subscription": "Sínithe",
    "trialUsed": "Triail: {{used}}/{{total}} úsáidte",
    "trialStatus": "Triail ar fáil",
    "activeStatus": "Sínithe gníomhach",
    "expiredStatus": "Sínithe imithe in éag",
    "unsubscribedStatus": "Níor shíniú",
    "about": "Fúinn",
    "version": "Leagan",
    "logout": "Logáil Amach",
    "logoutTitle": "Logáil Amach",
    "logoutConfirm": "An bhfuil tú cinnte gur mhaith leat logáil amach?",
    "noName": "Ainm gan socrú",
    "serverConnection": "Nasc freastalaí",
    "serverUrl": "URL an fhreastalaí",
    "serverEdit": "Cuir in eagar",
    "saveReconnect": "Sábháil agus nasc arís",
    "resetDefault": "Athshocraigh réamhshocruithe",
    "invalidServerUrlTitle": "URL freastalaí neamhbhailí",
    "invalidServerUrlMessage": "Cuir isteach URL freastalaí http nó https bailí, mar shampla https://example.com",
    "uiLanguageChangeFailed": "Theip ar athrú teanga an aip. Bain triail eile as.",
    "serverLanguageChangeFailed": "Theip ar athrú teanga an chomhrá. Bain triail eile as.",
    "timezoneChangeFailed": "Theip ar athrú crios ama. Bain triail eile as.",
    "autoSyncChangeFailed": "Theip ar nuashonrú sioncrónaithe uathoibríoch. Bain triail eile as.",
    "nameChangeFailed": "Theip ar nuashonrú ainm taispeána. Bain triail eile as.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Sonraí cuimhneacháin",
    "editTime": "Cuir in eagar am",
    "rename": "Athainmniú",
    "snooze": "Snooze",
    "snooze15": "Snooze 15 nóiméad",
    "pause": "Sos",
    "pauseReminder": "Sos cuimhneacháin",
    "resume": "Lean ar aghaidh",
    "resumeReminder": "Lean ar aghaidh le cuimhneachán",
    "skip": "Scipeáil an chéad cheann eile",
    "skipOccurrence": "Scipeáil an t-imeacht seo",
    "syncGoogle": "Sioncrónaigh le Google",
    "delete": "Scrios",
    "deleteTitle": "Scrios Cuimhneachán",
    "deleteConfirm": "Scriosfar an cuimhneachán seo go buan.",
    "deleteRecurringTitle": "Scrios Cuimhneachán Athfhillteach",
    "deleteRecurringMessage": "An maith leat an t-imeacht seo a shcipeáil nó an tsraith iomlán a scriosadh?",
    "deleteThisOccurrence": "Scipeáil an t-imeacht seo",
    "deleteEntireSeries": "Scrios an tsraith iomlán",
    "done": "Déanta",
    "markDone": "Marcáil mar dhéanta",
    "undo": "Athchóirigh",
    "undoPrompt": "An bhfuil sé uait gníomhach arís? Athchóirigh anois.",
    "recurring": "Athfhillteach",
    "nextRun": "Rith an chéad uair eile",
    "oneTime": "Uair amháin",
    "pending": "Ag fanacht",
    "sent": "Seolta",
    "paused": "Ar sos",
    "active": "Gníomhach",
    "snoozed": "Snoozed",
    "localTime": "Taispeánadh i do am áitiúil",
    "recurrence": "Athfhillteach",
    "created": "Cruthaithe",
    "tags": "Clibeanna",
    "fireCount": "Uaireanta a scaoileadh",
    "actions": "Gníomhartha",
    "none": "Níl",
    "snoozeFailed": "Theip ar snooze an chuimhneacháin",
    "pauseFailed": "Theip ar sos an chuimhneacháin",
    "resumeFailed": "Theip ar leanúint leis an gcuimhneachán",
    "skipFailed": "Theip ar scipeáil an chuimhneacháin",
    "doneFailed": "Theip ar marcáil an chuimhneacháin mar dhéanta",
    "undoFailed": "Theip ar athchóirigh stádas an chuimhneacháin",
    "deleteFailed": "Theip ar scriosadh an chuimhneacháin",
    "rescheduleTitle": "Athsceidealú?",
    "rescheduleMsg": "Tá an cuimhneachán seo ró-dhéanach. Ar mhaith leat é a athsceidealú?",
    "reschedule15": "I 15 nóiméad",
    "reschedule60": "I 1 uair",
    "keepOverdue": "Coinnigh mar atá"
  },
  "onboarding": {
    "slide1Title": "Fáilte go FishMemory",
    "slide1Sub": "Do chúntóir cuimhneacháin pearsanta — cumhachtaithe ag WhatsApp agus déanta do do phóca.",
    "slide2Title": "Comhrá go nádúrtha",
    "slide2Sub": "Clóscríobh cuimhneacháin mar a smaoiníonn tú: \"Cuimhnigh orm glaoch a chur ar mo mháthair amárach ag 3pm\" — déanaimid an chuid eile.",
    "slide3Title": "Ná caill rud ar bith",
    "slide3Sub": "Faigh fógraí tráthúla, eagraigh le clibeanna, agus fan ar bharr gach rud atá tábhachtach.",
    "getStarted": "Tosaigh",
    "next": "Ar aghaidh",
    "firstReminderTitle": "Cruthaigh do chéad chuimhneachán!",
    "firstReminderHint": "Bain triail as rud mar seo a chlóscríobh:",
    "firstReminderExample": "Cuimhnigh orm uisce a ól amárach ag 9 AM",
    "gotIt": "Tuigim!",
    "notifRationaleTitle": "Fan ar am",
    "notifRationaleBody": "Teastaíonn fógraí ó FishMemory chun cuimhneacháin a chur in iúl duit in am. Ní gheobhaidh tú foláirimh ach do chuimhneacháin a chruthaíonn tú.",
    "notifRationaleAllow": "Cumasaigh Fógraí",
    "notifRationaleLater": "B’fhéidir Níos déanaí",
    "swipeHint": "Sleamhnaigh ar dheis le haghaidh gníomhartha tapa →",
    "calendarDragHint": "Tarraing chun leathnú ↕"
  }
}
